import createActionButton from '@/components/actions/actions';
import { Button, type ButtonProps, type PolymorphicComponentProps } from '@mantine/core';
import { type PropsWithChildren } from 'react';

interface Props extends PolymorphicComponentProps<'button', ButtonProps> {
  sticky?: boolean;
}

export type ActionButtonProps = PropsWithChildren<typeof ActionButton>;

const ActionButton = createActionButton<Props>(function ActionButton({ sticky, ...props }) {
  if (sticky !== undefined) {
    return (
      <div
        css={{
          position: 'sticky',
          bottom: sticky ? 0 : '-1000px',
          transition: 'all 500ms ease',
          margin: 'calc(0px - var(--mantine-spacing-md))',
          padding: 'var(--mantine-spacing-md)',
          background: sticky ? 'var(--mantine-color-body)' : 'transparent',
          display: 'grid',
          zIndex: 1,
        }}
      >
        <Button {...props} />
      </div>
    );
  }

  return <Button {...props} />;
});
export default ActionButton;
